import Templates from '@/modules/templates/Templates'

export default function TemplatesPage() {
  return <Templates />
}
